import { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CustomDrawer from "../Drawer/main";
import NavBar from "../navbar/main";
import Icon from "../../../icons/main";
import { useLocation } from "react-router-dom";
import { routeMap } from "../../../config/config";
import ProfileAccordian from "../../../features/layout/components/sidebar/components/profileAccordian/main";

const LayoutHeader = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const toggleDrawerHandler = () => {
    setOpen((prev) => !prev);
  };
  return (
    <Box
      sx={{
        padding: "20px 15px 20px 15px",
        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        top: 0,
        zIndex: 1100,
        backgroundColor: "white",
        position: "sticky",
      }}
    >
      <Grid container spacing={1} alignItems={"center"} sx={{ width: "100%" }}>
        {isSmallScreen && (
          <Grid item xs={1}>
            {<MenuOutlinedIcon onClick={toggleDrawerHandler} />}
            <CustomDrawer open={open} drawerHandler={toggleDrawerHandler}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.4rem",
                  alignItems: "flex-start",
                  marginTop: "1rem",
                }}
              >
                <Box sx={{ alignSelf: "center", width: "12.5rem" }}>
                  <ProfileAccordian expanded={true} />
                </Box>
                <NavBar />
              </Box>
            </CustomDrawer>
          </Grid>
        )}
        <Grid item xs={7.5} sm={8.4}>
          <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
            {location.pathname === "/"
              ? Icon["Overview"]({
                  width: {
                    xs: "1.5rem",
                  },
                  height: {
                    xs: "1.5rem",
                  },
                  color: "#D9D9D9",
                })
              : Icon[routeMap[location.pathname.split("/")[1]]]({
                  width: {
                    xs: "1.5rem",
                  },
                  height: {
                    xs: "1.5rem",
                  },
                  color: "#D9D9D9",
                  strokeColor: "black",
                  circle: false,
                })}
            <Typography variant="LayoutHeading">
              {routeMap[location.pathname.split("/")[1]]}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default LayoutHeader;
